<template>
  <div>
    <!-- payment history modal -->
    <b-modal id="history_modal" title="결제 히스토리" size="xl"  class="modal-info" ok-only cancel-variant="primary">
      <b-table striped small responsive="sm" ref="_list_history" show-empty empty-text="not found"
        :items="history" :fields="fields_ko" :current-page="1" :per-page="(history || []).length" :sortBy="so.sk">
        <template slot="item_purchased_date" slot-scope="row">
          <span v-if="row.item.payer">{{row.item.purchase_units[0].payments.captures[0].create_time | datetime}}</span>
          <span v-else>{{row.item.purchased_at | datetime}}</span>
        </template>
        <template slot="item_company" slot-scope="row">
          <span v-if="row.item.payer">{{row.item.payer.email_address}}</span>
          <span v-else>{{row.item.pg_name}}</span>
        </template>
        <template slot="item_action" slot-scope="row">
          <span v-if="row.item.payer">{{row.item.purchase_units[0].description}}</span>
          <span v-else>{{row.item.action}}</span>
        </template>
        <template slot="item_method" slot-scope="row">
          <span v-if="row.item.payer">{{row.item.pg}}</span>
          <span v-else>{{row.item.pg}}</span>
        </template>
        <template slot="item_price" slot-scope="row">
          <span v-if="row.item.payer">{{row.item.purchase_units[0].amount.value}}</span>
          <span v-else>{{row.item.price}}</span>
        </template>
        <template slot="item_currency" slot-scope="row">
          <span v-if="row.item.payer">{{row.item.purchase_units[0].amount.currency_code}}</span>
          <span v-else>원</span>
        </template>
        <template slot="item_country" slot-scope="row">
          <span v-if="row.item.payer">{{row.item.address.country_code}}</span>
          <span v-else>한국</span>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>